import _ from 'lodash';
import { log, jwt_decode } from '@swiper/core';

import connectionSetup from './connection-setup';
import stationConnection from './station-connection';
import memberAuth from './member-auth';
import publishers from './publishers';

export default function configureChannels( app ) {

  connectionSetup( app );
  stationConnection( app );
  memberAuth( app );
  publishers( app );

}
